import React from 'react';
import { useDispatch } from 'react-redux';
import Modal from 'components/Modal';
import { Step } from 'components/SteppedModal';
import { YOUTUBE_CHANNEL_NEEDED_EDUCATION_LINK } from 'constants/social';
import { hideModal } from 'redux/modules/modal';
import { Dispatch } from 'redux/types';
import { YouTubeSocialShareStep } from '../../types';
import YouTubeChannelNeededStep from './YouTubeChannelNeededStep';

export default function useYouTubeChannelNeededStep(): Step<
  YouTubeSocialShareStep
> {
  const dispatch = useDispatch<Dispatch>();

  return {
    id: 'channel-needed',
    component: <YouTubeChannelNeededStep />,
    fluidFooterButtons: true,
    renderFooterButtons: () => [
      <Modal.FooterButton
        size="large"
        theme="submit"
        target="_blank"
        rel="noreferrer noopener"
        href={YOUTUBE_CHANNEL_NEEDED_EDUCATION_LINK}
        onClick={() => dispatch(hideModal())}
      >
        learn how to add one
      </Modal.FooterButton>,
    ],
  };
}
